import MonitoringServiceCallbackClientModal from './monitoring-service-callback-client-modal.vue'
export default MonitoringServiceCallbackClientModal
